import { BaseViewModel } from '../../../../../models/base/base-view-model';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ConnectionStatus } from '../../../../../models/web-sockets/enums/connection-status';
import { WebSocketService } from '../../../../../services/web-socket.service';
import { of } from 'rxjs';
import { DataSyncingService } from '../../../../../services/data-sync/data-syncing.service';

@Injectable()
export class SideNavFooterViewModel extends BaseViewModel {
  constructor(
    private webSocketService: WebSocketService,
    private dataSyncingService: DataSyncingService
  ) {
    super();
  }

  // @ts-ignore
  public readonly versionString$ = of(require('package.json')?.version);

  public readonly syncing$ = this.dataSyncingService.syncing$;

  public readonly socketConnectionStatus$ = this.webSocketService.socketConnectionStatus$;

  public readonly connectionTooltip$ = this.socketConnectionStatus$.pipe(
    map(connectionStatus => {
      switch (connectionStatus) {
        case ConnectionStatus.Connected:
          return 'Connected';
        case ConnectionStatus.Connecting:
          return 'Connecting...';
        case ConnectionStatus.Disconnected:
          return 'Connection error';
      }
    })
  );

  public readonly webSocketConnectionColor$ = this.socketConnectionStatus$.pipe(
    map(connectionStatus => {
      switch (connectionStatus) {
        case ConnectionStatus.Connected:
          return '#63d58f';
        case ConnectionStatus.Connecting:
          return '#ffd74b';
        case ConnectionStatus.Disconnected:
          return '#fa5555';
      }
    })
  );
}
